import React, { useEffect, useRef, useState } from 'react';
import { PlusOutlined } from '@ant-design/icons';
import type { InputRef } from 'antd';
import { Flex, Input, Popconfirm, Tag, theme, Tooltip } from 'antd';
import { useStore } from '../../inbox-store';
import _ from 'lodash';

const tagInputStyle: React.CSSProperties = {
  width: 64,
  height: 22,
  marginInlineEnd: 8,
  verticalAlign: 'top',
};

interface TagItem {
  id: string;
  removable: boolean;
  value: string;
}

const TagsComponent: React.FC = () => {
  const { token } = theme.useToken();
  const [tags, setTags] = useState<TagItem[]>([]);
  const [inputVisible, setInputVisible] = useState(false);
  const [inputValue, setInputValue] = useState('');
  const [editInputIndex, setEditInputIndex] = useState(-1);
  const [editInputValue, setEditInputValue] = useState('');
  const inputRef = useRef<InputRef>(null);
  const editInputRef = useRef<InputRef>(null);
  const activeContactModel = useStore((state) => state.activeContactModel);
  const activeContact = useStore((state) => state.activeContact);

  const deleteContactTag = useStore((state)=>state.deleteContactTag);
  const addContactTag = useStore((state)=>state.addContactTag);


  const [pendingTag, setPendingTag] = useState(null);



  useEffect(()=>{
    
    if(!activeContact || !activeContactModel.id){
      setTags([])
      return;
    }
  
    let contactTags = _.map(activeContactModel.tags,(tag)=>{
      return {
        id: tag.id,
        removable: !tag.tag_id,
        value: tag.value
      }
    })

    setTags(contactTags)

  },[activeContactModel])


  useEffect(() => {
    if (inputVisible) {
      inputRef.current?.focus();
    }
  }, [inputVisible]);

  useEffect(() => {
    editInputRef.current?.focus();
  }, [editInputValue]);

  const handleRemoveTag = (removedTag: string) => {
    deleteContactTag(removedTag)
  };

  const showInput = () => {
    setInputVisible(true);
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(e.target.value);
  };

  const handleInputConfirm = () => {
    if (inputValue && !tags.some(tag => tag.value === inputValue)) {
      console.log('add new tag',inputValue)
      addContactTag(inputValue)
    }
    setInputVisible(false);
    setInputValue('');
  };

  const handleEditInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEditInputValue(e.target.value);
  };

  const handleEditInputConfirm = () => {
    const newTags = [...tags];
    newTags[editInputIndex] = { ...newTags[editInputIndex], value: editInputValue };
    setTags(newTags);
    setEditInputIndex(-1);
    setEditInputValue('');
  };

  const tagPlusStyle: React.CSSProperties = {
    height: 22,
    background: token.colorBgContainer,
    borderStyle: 'dashed',
  };

  return (
    <Flex gap="4px 0" wrap>

      
      {_.map(tags,(tag, index) => {
       
        const isLongTag = tag.value.length > 20;

        const tagElem = (
          <Popconfirm
            key={tag.id}
            title={`Are you sure to remove "${tag.value}"?`}
            onConfirm={() => handleRemoveTag(tag.id)}
            onCancel={() =>setPendingTag(null)}
            placement='bottomLeft'
            okText="Yes"
            cancelText="No"
            open={pendingTag === tag.id} // Controls the popconfirm visibility
          >
              <Tag
                  closable={tag.removable}
                   style={{
                      backgroundColor: '#F8FFFB',
                      color: '#0F5132',
                      fontSize: '12px',
                      padding: '0 3px',
                      borderRadius: 4,
                      border: '1px solid #A7E6C5',
                      cursor: 'default',
                      margin: 2,
                      userSelect: 'none',
                    }}
                    onMouseEnter={(e: any) => (e.currentTarget.style.backgroundColor = '#F0FFF2')}
                    onMouseLeave={(e: any) => (e.currentTarget.style.backgroundColor = '#F8FFFB')}
                  onClose={(e) => {
                    e.preventDefault(); // Prevent immediate close
                    setPendingTag(tag.id); // Show popconfirm
                  }}
                >
                <span>
                  {isLongTag ? `${tag.value.slice(0, 20)}...` : tag.value}
                </span>
              </Tag>
          </Popconfirm>
        );


        return isLongTag ? (
          <Tooltip title={tag.value} key={tag.id}>
            {tagElem}
          </Tooltip>
        ) : (
          tagElem
        );
      })}
      {inputVisible ? (
        <Input
          ref={inputRef}
          type="text"
          size="small"
          style={tagInputStyle}
          value={inputValue}
          onChange={handleInputChange}
          onBlur={handleInputConfirm}
          onPressEnter={handleInputConfirm}
        />
      ) : (
        <Tag style={tagPlusStyle} icon={<PlusOutlined />} onClick={showInput}>
          New Tag
        </Tag>
      )}
    </Flex>
  );
};

export default TagsComponent;